
import Vue from 'vue';
import Vuex from 'vuex'
import VueMeta from 'vue-meta'
import App from './App.vue';
import { store } from './store'
import "@babel/polyfill"
Vue.use(Vuex)
Vue.use(VueMeta,{
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  ssrAttribute: 'data-vue-meta-server-rendered',
  tagIDKeyName: 'vmid',
  refreshOnceOnNavigation: true
})

const rootElement = document.createElement('div');
document.querySelector('.custom-page').appendChild(rootElement);
new Vue({ store, render: createElement => createElement(App) }).$mount(rootElement);